// extracted by mini-css-extract-plugin
export default {"container":"Lga-z","mediaElement":"Mga-z","close":"Nga-z"};